import { render, staticRenderFns } from "./noDataPage.vue?vue&type=template&id=1c6c7eb9"
import script from "./noDataPage.vue?vue&type=script&lang=js"
export * from "./noDataPage.vue?vue&type=script&lang=js"
import style0 from "./noDataPage.vue?vue&type=style&index=0&id=1c6c7eb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports